import { TranslationType } from '../../../../HbtPortfolioManagementTable/types';

export const loanStatusMapping = (t: TranslationType) => {
  const mapping = {
    '01': t('Received'),
    '02': t('Passed'),
    '03': t('Failed'),
    '04': t('Review-Required'),
    '09': t('Deleted')
  };
  return mapping;
};
